import React, { useEffect } from 'react'
import MicrosoftLogin from 'react-microsoft-login';
import { emptyUser, Roles, User } from '../Interfaces/Account';

require("dotenv").config();

interface Props{
    setUser:React.Dispatch<React.SetStateAction<User>>,
}

function Microsoft({setUser}:Props) {

    useEffect(()=>{
        if(process.env.REACT_APP_WEBBISTE === "http://localhost:3000"){
        setUser({
            active:true,
            class:"",
            displayName:"Sebastian Ahlman",
            email:"hawaiilive@outlook.com",
            givenName:"Sebastian",
            id:"00123123",
            surName:"Ahlman",
            accountID:"00123123",
            role:Roles.student
        });
    }
    },[setUser])
    

    const authHandler = (err:any, data:any)=>{
        if(err == null){
            var user:User = {
                active:true,
                class:"",
                displayName:data.displayName,
                email:data.mail,
                givenName:data.givenName,
                id:data.id,
                surName:data.surname,
                accountID:data.id,
                role:Roles.student
            }

            setUser(user);
            return;
        }

        setUser(emptyUser);
    }

    let key = process.env.REACT_APP_MICROSOFT_KEY === undefined ? "" : process.env.REACT_APP_MICROSOFT_KEY;

    return (
        <div>
            <MicrosoftLogin clientId={key} withUserData={true} authCallback={authHandler}/>
        </div>
    )
}

export default Microsoft
